import { CustomDataAttrGtmClick } from '../../../features/google/customDataType';
import { DefaultProps } from '../../../types/DefaultProps';

import styles from './ButtonNav.module.scss';

import type { FC, ReactNode } from 'react';

import { assertNever } from '@/packages/nurse-senka-frontend-sdk';

type ButtonActiveProps = {
  link?: string;
  children?: ReactNode;
  active?: boolean;
  customDataAttrGtmClick?: CustomDataAttrGtmClick;
};

// Black Styled
const ButtonNavBlack: FC<ButtonActiveProps> = ({
  active,
  link,
  children,
  customDataAttrGtmClick,
}) => (
  <>
    {active ? (
      <a
        className={styles['button-nav-black-active']}
        href={link}
        data-gtm-click={customDataAttrGtmClick}
      >
        {children}
      </a>
    ) : (
      <a
        className={styles['button-nav-black-default']}
        href={link}
        data-gtm-click={customDataAttrGtmClick}
      >
        {children}
      </a>
    )}
  </>
);

// White Styled
const ButtonNavWhite: FC<ButtonActiveProps> = ({
  active,
  link,
  children,
  customDataAttrGtmClick,
}) => (
  <>
    {active ? (
      <a
        className={styles['button-nav-white-active']}
        href={link}
        data-gtm-click={customDataAttrGtmClick}
      >
        {children}
      </a>
    ) : (
      <a
        className={styles['button-nav-white-default']}
        href={link}
        data-gtm-click={customDataAttrGtmClick}
      >
        {children}
      </a>
    )}
  </>
);

export type ButtonProps = DefaultProps & {
  children?: ReactNode;
  link?: string;
  active?: boolean;
  color: 'default' | 'white';
  customDataAttrGtmClick?: CustomDataAttrGtmClick;
};

export const ButtonNav: FC<ButtonProps> = ({
  children,
  color,
  link,
  active,
  customDataAttrGtmClick,
}) => {
  switch (color) {
    case 'default':
      return (
        <ButtonNavBlack
          link={link}
          data-gtm-click={customDataAttrGtmClick}
          active={active}
        >
          {children}
        </ButtonNavBlack>
      );
    case 'white':
      return (
        <ButtonNavWhite
          link={link}
          data-gtm-click={customDataAttrGtmClick}
          active={active}
        >
          {children}
        </ButtonNavWhite>
      );
    default:
      return assertNever(color);
  }
};
